module.exports = __webpack_public_path__ + "img/discuss-dude.e505bed2.svg";